<template>
    <section id="banner-videos-paises">
        <div class='banner-video-paises'>
            <video muted autoplay loop playsinline  class="banner-video-paises__video">
                <source :src='"/video/video_inicio_"+ $root.alias_pais +".webm"' type='webm'>
                <source :src='"/video/video_inicio_"+ $root.alias_pais +".mp4"'>
            </video>
            <div class='banner-video-paises__content-banner container'>
                <div class="row">
                    <div class='col-12 banner-video-paises__title' :class="{'ajust-banner-obtener-app': $root.showBannerObtenerApp, 'banner-video-paises__title--campania': this.campania == 'true'}">
                        <h2>Licitaciones en {{ $root.paisOriginalName }}</h2>
                    </div>
                    <div class='col-12'>
                        <p v-html="bannerVideoText"></p>
                    </div>
                    <div class='col-12 text-center'>
                        <cta-button
                            link="/registrarse"
                            class="shadow-button banner-video-paises__button"
                            level="success"
                            :text="$t($root.lenguaje_pais+'.registro.texto_general', { dias: $root.currentTrialDays })"
                            :hiddentext="$t($root.lenguaje_pais+'.registro.texto_hidden', { dias: $root.currentTrialDays })"
                        ></cta-button>
                    </div>
                    <div class='d-flex justify-content-center banner-video-paises__franja'>
                        <franja-procesos-fuentes></franja-procesos-fuentes>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import FranjaProcesosFuentes from './FranjaProcesosFuentes.vue';

    /* eslint-disable */
    export default {
        name: 'banner-video-pais',
        data: () => ({
            fuentes: {
                pan: 'Panamá Compra',
                col: 'SECOP I, SECOP II',
                chl: 'Chile Compra',
                ecu: 'SERCOP',
                per: 'Seace',
                bol: 'Sicoes'
            }
        }),
        props: {
            campania: String
        },
        components: {
            'franja-procesos-fuentes': FranjaProcesosFuentes
        },
        computed: {
            bannerVideoText: function () {
                if (this.$te(`${this.$root.alias_pais}.banner_video.texto`)) {
                    return this.$t(`${this.$root.alias_pais}.banner_video.texto`);
                }

                return this.$t('all.banner_video.texto');
            }
        }
    }
</script>
